/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
<svg id="Livello_1" data-name="Livello 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169 82">
  <defs>
    <style>
      .cls-1 {
        stroke-width: 0px;
      }
    </style>
  </defs>
  <path class="cls-1" d="M72.9,22.72c10.24,0,18.37,8.17,18.31,18.53-.06,10.25-8.67,18.24-18.71,18.08-9.74-.15-17.94-8.43-17.91-18.37.03-10.09,8.22-18.24,18.31-18.24ZM59.67,41.02c.01,7.34,5.99,13.22,13.43,13.21,7.18,0,13.07-6.02,13.06-13.34,0-7.3-6.01-13.11-13.54-13.09-7.02.01-12.96,6.08-12.95,13.23Z"/>
  <path class="cls-1" d="M151.44,58.87h-5.08v-.93c0-5.51,0-11.01,0-16.52,0-2.57-.39-5.06-1.62-7.35-2.42-4.49-6.24-6.63-11.3-6.24-4.88.38-8.08,3.15-9.89,7.6-.68,1.67-.97,3.44-.97,5.25,0,5.74,0,11.48,0,17.21v.97h-5.17v-.85c0-5.66-.03-11.32.01-16.98.04-5.13,1.54-9.75,5.22-13.46,7.97-8.04,21.52-5.89,26.67,4.19,1.41,2.76,2.13,5.71,2.16,8.79.05,5.89.01,11.78.01,17.67,0,.2-.02.4-.04.64Z"/>
  <path class="cls-1" d="M45.21,50.43c1.15,1.16,2.31,2.31,3.47,3.48-3.21,3.78-10.35,6.72-17.6,4.79-7.69-2.04-13.23-8.85-13.55-17.05-.32-8.04,4.56-15.08,11.97-17.82,7.32-2.71,15.07-.26,19.18,4.24-1.17,1.17-2.34,2.34-3.51,3.51-5.83-5.57-14.24-4.67-19.02.41-4.63,4.92-4.74,12.61-.18,17.83,4.37,5.01,13.09,6.52,19.24.62Z"/>
  <path class="cls-1" d="M100.97,23.15h5.01v35.72h-5.01V23.15Z"/>
</svg>
</template>

<script>
export default {
  name: 'BrandLogo'
}
</script>
